class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-acc-trigger').on('click', function() {
      $(this).next().slideToggle();
      $(this).find('.js-acc-plus').toggleClass('is-active');
    });

    $(".js-banner-close").click(function () {
      $(".s-fixed").fadeOut();
    });
  
    $(window).on("scroll", function () {
      var footerOffset = $(".js-footer").offset().top;
      var scrollBottom = $(window).scrollTop() + $(window).height();
  
      if (scrollBottom >= footerOffset) {
        $(".s-fixed").fadeOut();
      } else if (!$(".js-banner-close").hasClass("closed")) {
        $(".s-fixed").fadeIn();
      }
    });
  
    $(".js-banner-close").click(function () {
      $(this).addClass("closed");
    });    
    
  }
}
